import { useState } from 'react';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '@core/api.js';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('Mot de passe trop court (8 caractères minimum).');
    if (password !== confirm) return setError('Les mots de passe ne correspondent pas.');
    setLoading(true);
    try {
      await api.post('/v1/auth/reset-password', { token, password });
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err?.response?.data?.error || 'Lien invalide ou expiré.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={submit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h5" fontWeight={700}>Nouveau mot de passe</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      <TextField label="Nouveau mot de passe" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
      <TextField label="Confirmer" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
      <Button type="submit" variant="contained" disabled={loading || !token}>Réinitialiser</Button>
    </Box>
  );
}
